import { TOGGLE_COLLAPSE } from '../constants';

export type Action = { type: TOGGLE_COLLAPSE; payload: boolean };

export const setCollapse = (isCollapse: boolean): Action => ({
  type: TOGGLE_COLLAPSE,
  payload: isCollapse,
});
